import { apiFetch } from "@/lib/api";

const CTA_KEY = "readoo_signup_cta";
const VISIT_KEY = "readoo_visit";

// Ricorda quale invito ha portato alla registrazione (feed_per_te, salva, vantaggi, founder, poll, coupon, altro).
export function rememberSignupCta(cta, source = window.location.pathname) {
  try { localStorage.setItem(CTA_KEY, JSON.stringify({ cta, source, at: Date.now() })); } catch {}
}

export function sendSignupSource() {
  let v = null;
  try { v = JSON.parse(localStorage.getItem(CTA_KEY) || "null"); localStorage.removeItem(CTA_KEY); } catch {}
  const fresh = v && Date.now() - v.at < 7 * 24 * 3600 * 1000;
  apiFetch(`/auth/signup-source`, { method: "POST", auth: true, body: fresh ? { cta: v.cta, source: v.source || "" } : { cta: "altro", source: "" } }).catch(() => {});
}

// Visitatore unico del giorno, anonimo: un identificativo casuale del browser, inviato una volta al giorno.
export function pingVisit() {
  try {
    const today = new Date().toISOString().slice(0, 10);
    const v = JSON.parse(localStorage.getItem(VISIT_KEY) || "null") || {};
    if (v.day === today) return;
    const vid = v.vid || (crypto.randomUUID ? crypto.randomUUID() : `${Date.now()}${Math.random()}`.replace(".", ""));
    localStorage.setItem(VISIT_KEY, JSON.stringify({ vid, day: today }));
    apiFetch(`/visit`, { method: "POST", auth: false, body: { vid } }).catch(() => {});
  } catch {}
}

export const trackClick = (kind) => apiFetch(`/track/click`, { method: "POST", auth: true, body: { kind } }).catch(() => {});

let savedIds = null;
const listeners = new Set();
const emit = () => listeners.forEach((fn) => fn(savedIds));

export async function loadSavedIds(force = false) {
  if (savedIds && !force) return savedIds;
  const r = await apiFetch(`/me/saved/ids`, { auth: true });
  savedIds = new Set(r.ids || []);
  emit();
  return savedIds;
}

export function onSavedChange(fn) { listeners.add(fn); return () => listeners.delete(fn); }

export async function toggleSaved(articleId) {
  const ids = await loadSavedIds();
  const on = ids.has(articleId);
  await apiFetch(`/me/saved/${articleId}`, { method: on ? "DELETE" : "POST", auth: true });
  on ? ids.delete(articleId) : ids.add(articleId);
  emit();
  return !on;
}

export const resetSaved = () => { savedIds = null; };
export const getSaved = () => apiFetch(`/me/saved?limit=50`, { auth: true });
export const getSummary = () => apiFetch(`/me/summary`, { auth: true });
export const finishOnboarding = () => apiFetch(`/me/onboarding`, { method: "PUT", auth: true });

// Dopo l'accesso: chi si è appena registrato passa dal breve onboarding (una volta sola), gli altri vanno dove stavano andando.
export function isFreshSignup(user) {
  const t = Date.parse(user?.created_at || "");
  return !!user && !user.onboarding_completed && user.role === "user" && Date.now() - t < 15 * 60 * 1000;
}
